import Quickview from './Quickview'

export default {
  Quickview
}



// WEBPACK FOOTER //
// ./src/app/configuration/Genesis/theme/components/quickview/index.js